import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import {EventContentArg} from '@fullcalendar/core'

export const Cal = () => {
  // Custom event renderer
  const renderEventContent = (eventInfo: EventContentArg) => {
    const {title, extendedProps} = eventInfo.event
    const startTime = eventInfo.event.start?.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })

    return (
      <div className='cursor-pointer truncate'>
        <div className='truncate font-medium'>{title}</div>
        <div className='truncate text-sm text-gray-500'>{`${startTime} - ${extendedProps.className}`}</div>
      </div>
    )
  }

  return (
    <div className='w-full bg-white rounded-lg shadow p-4 mb-4'>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        initialView='dayGridMonth'
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
        }}
        //events={events}
        eventContent={renderEventContent}
      />
    </div>
  )
}
